import { render, staticRenderFns } from "./league_CBA_matchItem.vue?vue&type=template&id=1d8428be&scoped=true"
import script from "./league_CBA_matchItem.vue?vue&type=script&lang=js"
export * from "./league_CBA_matchItem.vue?vue&type=script&lang=js"
import style0 from "./league_CBA_matchItem.vue?vue&type=style&index=0&id=1d8428be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8428be",
  null
  
)

export default component.exports